export const OVERLAY_STYLES = {
  position: 'fixed',
  height: '100%',
  width: '100%',
  'z-index': 2000,
  top: 0,
  left: 0,
}
